/**
 * Oftentimes when we add Redo to the cart using the toggle, it happens after some side cart has rendered.
 * Many themes rely on the position of the line item in the cart to be current, and items are added to the top, changing the line number
 * for anything already in there. So we have to do our best to re-render the cart whenever we add/remove redo.
 *
 * This function is called after we add/remove redo from the cart, and contains all of the known methods for reloading the cart in various themes.
 */
export async function renderCart() {
  /* Add a small delay to ensure cart operations are processed,
   * without this timeout bugs occur on a variety of stores using cartAddToEnd.
   */
  await new Promise((resolve) => setTimeout(resolve, 100));

  try {
    if (window.Shopify?.shop === "augustine-boutique.myshopify.com") {
      await (globalThis as any).theme.cart.updateAllHtml();
    }

    if (window.Shopify?.shop === "hatch-insane-deal.myshopify.com") {
      /**
       * async function refreshCart(delay = 2000)
       * Refreshes the cart content and state. Pass input delay in milliseconds. Default is 2000.
       */
      await (globalThis as any).MiraCart?.refreshCart(0);
    }

    if (
      window.Shopify?.shop === "undiesforever.myshopify.com" ||
      window.Shopify?.shop === "baltic-born.myshopify.com"
    ) {
      (globalThis as any).publish("cart-update", {});
    }

    if (window.Shopify?.shop === "thevaultproscooters.myshopify.com") {
      if (window.customElements.get("cart-items") !== undefined) {
        const cartItems: any = document.querySelector("cart-items");
        if (cartItems) {
          await cartItems.refresh();
        }
      }
    }

    if (
      window.Shopify?.shop === "rooney.myshopify.com" ||
      window.Shopify?.shop === "bigshoes-store.myshopify.com" ||
      window.Shopify?.shop === "charming-and-main.myshopify.com" ||
      window.Shopify?.shop === "49274c.myshopify.com" // Shevibe
    ) {
      window.location.reload();
    }

    if (typeof window.SLIDECART_UPDATE === "function") {
      window.SLIDECART_UPDATE();
    }
    if (typeof window.ajaxCart?.load === "function") {
      window.ajaxCart.load();
    }
    if (typeof window.reloadCart === "function") {
      window.reloadCart();
    }
  } catch (e) {
    console.error("Failed to re-render cart: ", e);
  }
}
